export enum AccountingCategoriesCount {
    MicrosIpNetSales = 4,
    AllianceHospNetSales = 8,
    XmlPosNetSales = 17,
    XmlPosDiscount = 16,
    XmlPosServiceCharge = 16,
}
